/**
 * @typedef {import('vue').default} Vue
 */
import * as Sentry from '@sentry/vue';
import pkg from '../../package.json';

/**
 *
 * HOW TO CREATE A NEW SENTRY PROJECT and get the dsn value:
 * LOGIN HERE: https://garmin-07.sentry.io/projects/
 * press the + Create Project button
 * Choose your platform -> Vue.js
 * Choose I'll create my own alerts later
 * Choose a name for your project -> eg: www-compare-client
 * TODO: delete this comment when done
 *
 */

/**
 * Initializes Sentry for error tracking in a Vue.js application.
 * @param {Vue} app - The Vue instance representing the application.
 */
export const sentry = (app) => {
  // Sentry - Only run in production
  // TODO: Update this with your app's domain/sub-domain
  if (window?.location?.host === 'www.garmin.com') {
    Sentry.init({
      app,
      dsn: 'https://afdc7566debf4018b3273bc5c075f587@o430870.ingest.sentry.io/6324207',
      release: `${pkg.name}@${pkg.version}`,
      environment: 'production',
      logErrors: true,
      allowUrls: [
        // Allow errors from our application code
        /\/m\/assets\//i, // Update this with the correct path to your assets :-)
      ],
      /* eslint-disable max-len */
      /**
       *
       * @param {object} event     - Sentry processed event object provide to beforeSend callback
       *                           - More details can be found here: https://docs.sentry.io/platforms/javascript/guides/vue/configuration/filtering/#using-platformidentifier-namebefore-send-
       * @returns {object|null}  - Returns null if event is intended to be filtered out from logging to Sentry, otherwise it returns the event object
       */
      /* eslint-enable max-len */
      beforeSend(event) {
        const exceptionDetails = event?.exception?.values[0];
        const exceptionValue = exceptionDetails?.value;
        const exceptionStackTrace = exceptionDetails?.stacktrace;

        // Exceptions without a value or a stack trace are non-actionable
        if (!exceptionValue || !exceptionStackTrace) {
          return null;
        }

        // Otherwise log error to Sentry
        return event;
      },
    });
  }
};

export default sentry;
